import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Header } from "./components/Header/Header";
import { Menu } from "./components/Menu/Menu";
import { Rules } from "./layout/Rules/Rules";
import { Landing } from "./layout/Landing/Landing.js";
import { GlobalStyles, StyledApp } from "./global-styles/GlobalStyles";
import ContactUs from "./components/Form/ContactUs";
import { CookieSetting } from "cookiesetting-component";

export default function App() {
  const [menuToggle, setMenuToggle] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const toggleForm = () => setShowForm(!showForm);
  const [elementId, setElementId] = useState("mytruehome");
  const navigate = useNavigate();
  const location = useLocation();
  const handleMenuToggle = (menuToggle) => {
    setMenuToggle(!menuToggle);
  };
  const handleMenuNav = (route, menuToggle) => {
    handleMenuToggle(menuToggle);
    navigate(route);
  };

  const handleScroll = (id) => {
    navigate("/mytruehome");
    handleMenuToggle(true);
    setElementId(id);
    if (location.pathname === "/mytruehome") {
      const x = document.querySelector(`#${id}`);
      const windowWidth = window.innerWidth;
      if (windowWidth < 600 && id === "swmc") {
        const swmcScrollTop = x.offsetTop + 200;
        x.scrollTo({ top: swmcScrollTop, behavior: "smooth" });
      } else {
        x.scrollTo({ top: x.offsetTop - 100, behavior: "smooth" });
      }
    }
  };

  const year = new Date().getFullYear();

  return (
    <StyledApp>
      <GlobalStyles />

      <Modal size="lg" className="mt-1"
        show={showForm}
        onHide={toggleForm}
        keyboard={false}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ContactUs />
        </Modal.Body>
      </Modal>

      <Header
        navigate={navigate}
        handleScroll={handleScroll}
        handleMenuToggle={handleMenuToggle}
        menuToggle={menuToggle}
        toggleForm={toggleForm}
      />
      <Menu
        handleMenuNav={handleMenuNav}
        handleMenuToggle={handleMenuToggle}
        handleScroll={handleScroll}
        menuToggle={menuToggle}
        toggleForm={toggleForm}
      />
      <Routes>
        <Route
          path="/mytruehome/contest-rules"
          element={<Rules year={year} />}
        />
        <Route
          exact
          path="/mytruehome"
          element={<Landing elementId={elementId} year={year} />}
        />
        <Route path="*" element={<Navigate to="/mytruehome" replace />} />
      </Routes>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </StyledApp>
  );
}
